import styled from '@emotion/styled';
import theme from '../../theme';

export const Container = styled('div')`
  position: absolute;
  right: ${theme.spacing(1)};
  top: ${theme.spacing(1)};
  z-index: 1;

  @media (max-width: 768px) {
    right: ${theme.spacing(0)};
    top: ${theme.spacing(0)};
  }
`;
